import { LegacyProducts } from "@/types/widget";

export default {
  // [LegacyProducts.WIND]: ['timeseries'],
  // [LegacyProducts.WIND_DIRECTION]: ['timeseries', 'wind'],
  [LegacyProducts.GENERIC]: [
    "highcharts",
    "html",
    "iframe",
    "image",
    "images",
    "link",
    "probabilities",
    "radar",
    "report",
    "seiches",
    "sight",
    "text",
    "textcode",
    "timeseries",
    "wind",
  ],
  [LegacyProducts.STATIC_FILE]: [
    "link",
    "iframe",
    "text",
    "html",
    "timeseries",
    "image",
    "highcharts",
  ],
  [LegacyProducts.FILE]: [
    "link",
    "iframe",
    "text",
    "html",
    "timeseries",
    "image",
    "highcharts",
    "inline_pdf",
  ],
  [LegacyProducts.FILES]: ["images", "links"],
  [LegacyProducts.OPMET]: ["html"],
};
